!(function (e, n) {
    "object" == typeof exports && "undefined" != typeof module
        ? (module.exports = n())
        : "function" == typeof define && define.amd
            ? define(n)
            : (((e = e || self).__vee_validate_locale__it = e.__vee_validate_locale__it || {}), (e.__vee_validate_locale__it.js = n()));
})(this, function () {
    "use strict";
    var e,
        n = {
            name: "it",
            messages: {
                _default: function (e) {
                    return "Il valore del campo " + e + " non è valido";
                },
                after: function (e, n) {
                    return "Il " + e + " deve essere dopo " + n[0];
                },
                alpha: function (e) {
                    return "Il campo " + e + " può contenere solo caratteri alfabetici";
                },
                alpha_dash: function (e) {
                    return "Il campo " + e + " può contenere caratteri alfa-numerici così come lineette e trattini di sottolineatura";
                },
                alpha_num: function (e) {
                    return "Il campo " + e + " può contenere solo caratteri alfanumerici";
                },
                alpha_spaces: function (e) {
                    return "Il campo " + e + " può contenere solo caratteri alfanumerici così come spazi";
                },
                before: function (e, n) {
                    return "Il campo " + e + " deve essere prima di " + n[0];
                },
                between: function (e, n) {
                    return "Il campo " + e + " deve essere compreso tra " + n[0] + " e " + n[1];
                },
                confirmed: function (e, n) {
                    return "Il campo " + e + " non corrisponde con " + n[0];
                },
                credit_card: function (e) {
                    return "Il campo " + e + " non è valido";
                },
                date_between: function (e, n) {
                    return "La " + e + " deve essere compresa tra " + n[0] + " e " + n[1];
                },
                date_format: function (e, n) {
                    return "La " + e + " deve essere nel formato " + n[0];
                },
                decimal: function (e, n) {
                    void 0 === n && (n = []);
                    var r = n[0];
                    return void 0 === r && (r = "*"), "Il campo " + e + " deve essere numerico e può contenere" + (r && "*" !== r ? " " + r : "") + " punti decimali";
                },
                digits: function (e, n) {
                    return "Il campo " + e + " deve essere numerico e contenere esattamente " + n[0] + " cifre";
                },
                dimensions: function (e, n) {
                    return "Il campo " + e + " deve essere " + n[0] + " x " + n[1];
                },
                eighteen_yo: function (e){
                    return 'Devi essere più grande di 18 anni.';
                },
                email: function (e) {
                    return "La tua email non è valida. Correggila, per favore.";
                },
                excluded: function (e) {
                    return "Il campo " + e + " deve avere un valore valido";
                },
                ext: function (e) {
                    return "Il campo " + e + " deve essere un file valido";
                },
                handle: function (e){
                    return 'Min. 4 e max. 15 caratteri. \n' +
                        'Solo lettere, numeri e - . _';
                },
                image: function (e) {
                    return "Il campo " + e + " deve essere un'immagine";
                },
                included: function (e) {
                    return "Il campo " + e + " deve avere un valore valido";
                },
                ip: function (e) {
                    return "Il campo " + e + " deve essere un indirizzo IP valido";
                },
                length: function (e, n) {
                    var r = n[0],
                        o = n[1];
                    return o ? "La lunghezza del campo " + e + " deve essere compreso tra " + r + " e " + o : "La lunghezza del campo " + e + " deve essere " + r;
                },
                max: function (e, n) {
                    return "Il campo " + e + " non può essere più lungo di " + n[0] + " caratteri";
                },
                max_value: function (e, n) {
                    return "Il campo " + e + " deve essere minore o uguale a " + n[0];
                },
                mimes: function (e) {
                    return "Il campo " + e + " deve avere un tipo di file valido";
                },
                min: function (e, n) {
                    return "La tua " + e + " deve essere lunga almeno " + n[0] + " caratteri.";
                },
                min_value: function (e, n) {
                    return "Il campo " + e + " deve essere maggiore o uguale a " + n[0];
                },
                numeric: function (e) {
                    return "Il campo " + e + " può contenere solo caratteri numerici";
                },
                regex: function (e) {
                    return "Il campo " + e + " non ha un formato valido";
                },
                required: function (e) {
                    return "Il campo " + e + " è richiesto";
                },
                size: function (e, n) {
                    return (
                        "Il campo " +
                        e +
                        " deve essere inferiore a " +
                        (function (e) {
                            var n = 1024,
                                r = 0 === (e = Number(e) * n) ? 0 : Math.floor(Math.log(e) / Math.log(n));
                            return 1 * (e / Math.pow(n, r)).toFixed(2) + " " + ["Byte", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][r];
                        })(n[0])
                    );
                },
                url: function (e) {
                    return "Il campo " + e + " non è un URL valido";
                },
            },
            attributes: {},
        };
    return "undefined" != typeof VeeValidate && VeeValidate.Validator.localize((((e = {})[n.name] = n), e)), n;
});
